/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import Vue from 'vue';

var files = require.context('../Global', true, /\.vue$/i);

files.keys().map(files).forEach(function (v) {
  Vue.component(v.default.name, v.default);
});